import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Availability_Status_Enum } from '@kheops/graphql';
import { useTranslation } from 'react-i18next';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Radio } from '@mui/material';
import FilterDisplay, { FilterDisplayMode } from '../../search/filters/FilterDisplay';

export type AvailabilityFilterValues = Availability_Status_Enum | 'ALL';

interface ProductAvailabilityFilterProps {
  availabilityFilter: AvailabilityFilterValues;
  onChange: (availabilityValue: AvailabilityFilterValues) => void;
  mode?: FilterDisplayMode;
}

export default function ProductAvailabilityFilter({ availabilityFilter, onChange, mode = 'POPOVER' }: ProductAvailabilityFilterProps): React.JSX.Element {
  const { t } = useTranslation(['products', 'common']);

  const options: { value: AvailabilityFilterValues; label: string }[] = [
    { value: 'ALL', label: t('common:all_products') },
    { value: Availability_Status_Enum.Available, label: t('products:available_products') },
    { value: Availability_Status_Enum.Unavailable, label: t('products:unavailable_products') },
  ];

  const filterContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <List>
        {options.map(({ value, label }) => (
          <ListItemButton
            key={value}
            onClick={() => onChange(value)}
          >
            <ListItemText primary={label} />
            <ListItemIcon>
              <Radio
                edge="start"
                checked={availabilityFilter === value}
              />
            </ListItemIcon>
          </ListItemButton>
        ))}
      </List>
    </Box>
  );

  return (
    <FilterDisplay
      mode={mode}
      name="availabilityFilter"
      activeItemCount={availabilityFilter === 'ALL' ? 0 : 1}
      icon={<RemoveRedEyeOutlinedIcon />}
      label={t('products:availability')}
      content={filterContent}
    />
  );
}
